export const generateCandleData = (count: number): number[][] => {
    let previousClose = 10;
    const trend = 0.7;
    return Array.from({
        length: count
    }, () => {
        const open = previousClose;
        const fluctuation = (Math.random() - 0.5) * 50;
        const close = open + fluctuation + trend;
        previousClose = close;
        
        const low = Math.min(open, close) - Math.random() * 3;
        const high = Math.max(open, close) + Math.random() * 3;
        return [open, close, low, high];
    });
};
